import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { userApi } from '@Redux/api/user.api'

import calendarEventsReducer from '@Redux/slices/calendar/slice'
import configReducer from '@Redux/slices/config/ConfigSlice'
import countriesReducer from '@Redux/slices/config/CountriesSlice'
import timezonesReducer from '@Redux/slices/config/TimezonesSlice'
import discoverReducer from '@Redux/slices/discover/slice'

import ModalReducer from '@Redux/slices/modals/ModalSlice'
import newsReducer from '@Redux/slices/news/slice'
import NotificationSlice from '@Redux/slices/notifications/NotificationSlice'
import platformNewsReducer from '@Redux/slices/platform_news/slice'
import exchangeOrdersReducer from '@Redux/slices/profile/exchange_order/ExchangeOrderSlice'
import InvoicesReducer from '@Redux/slices/profile/invoices/InvoiceSlice'

import userNotificationSlice from '@Redux/slices/profile/notification/NotificationSlice'

import spotOrdersReducer from '@Redux/slices/profile/spot_order/SpotOrderSlice'
import TransactionsReducer from '@Redux/slices/profile/transactions/TransactionSlice'
import WalletsReducer from '@Redux/slices/profile/wallets/WalletSlice'
import QueueTaskSlice from '@Redux/slices/queue_task/QueueTaskSlice'
import rateReducer from '@Redux/slices/rate/RatesSlice'
import reportsReducer from '@Redux/slices/reports/ReportsSlice'
import FrontServiceConnectionReducer from '@Redux/slices/sockets/FrontServiceConnectionSlice'
import ProxyServiceConnectionSlice from '@Redux/slices/sockets/ProxyServiceConnectionSlice'
import PublicServiceConnectionSlice from '@Redux/slices/sockets/PublicServiceConnectionSlice'
import UserServiceConnectionSliceReducer from '@Redux/slices/sockets/UserServiceConnectionSlice'
import termsAndConditionsReducer from '@Redux/slices/terms_and_conditions/TermsAndConditionsSlice'
import PriceAlertReducer from '@Redux/slices/trade/alerts/PriceAlertSlice'

import OrderSliceReducer from '@Redux/slices/trade/trades/OrdersSlice'
import TradeSliceReducer from '@Redux/slices/trade/trades/TradesSlice'
import userReducer from '@Redux/slices/user/UserSlice'
import watchlistsReducer from '@Redux/slices/watchlist/slice'

const rootReducer = combineReducers({
  [userApi.reducerPath]: userApi.reducer,
  user_service_connector: UserServiceConnectionSliceReducer,
  front_service_connector: FrontServiceConnectionReducer,
  public_service_connector: PublicServiceConnectionSlice,
  proxy_service_connector: ProxyServiceConnectionSlice,
  config: configReducer,
  countries: countriesReducer,
  timezones: timezonesReducer,
  notifications: NotificationSlice,
  user: userReducer,
  spot_order: spotOrdersReducer,
  invoices: InvoicesReducer,
  transactions: TransactionsReducer,
  spot_exchange: exchangeOrdersReducer,
  wallets: WalletsReducer,
  modals: ModalReducer,

  queueTasks: QueueTaskSlice,

  user_notification: userNotificationSlice,
  rates: rateReducer,

  terms_and_conditions: termsAndConditionsReducer,
  trades: TradeSliceReducer,
  orders: OrderSliceReducer,
  priceAlerts: PriceAlertReducer,
  reports: reportsReducer,
  discover: discoverReducer,
  news: newsReducer,
  platformNews: platformNewsReducer,
  calendarEvents: calendarEventsReducer,
  watchlists: watchlistsReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(userApi.middleware),
})

setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
